import { z } from 'zod';

/**
 * RFC-9457 problem+json error body.
 * See https://www.rfc-editor.org/rfc/rfc9457
 */
export interface ProblemDetails {
  type: string;
  title: string;
  status: number;
  detail?: string;
  instance?: string;
  /** Optional machine-readable error code for clients. */
  code?: string;
  /** Optional validation issues (field -> messages). */
  errors?: Record<string, string[]>;
}

export const problemSchema = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  instance: z.string().optional(),
  code: z.string().optional(),
  errors: z.record(z.array(z.string())).optional(),
});

export const PROBLEM_CONTENT_TYPE = 'application/problem+json';

export function problem(
  status: number,
  title: string,
  opts: Partial<Omit<ProblemDetails, 'status' | 'title'>> = {},
): ProblemDetails {
  return {
    type: opts.type ?? 'about:blank',
    title,
    status,
    ...(opts.detail ? { detail: opts.detail } : {}),
    ...(opts.instance ? { instance: opts.instance } : {}),
    ...(opts.code ? { code: opts.code } : {}),
    ...(opts.errors ? { errors: opts.errors } : {}),
  };
}
